import React from 'react';
import { ReactComponent as OkInShieldSvg } from '../../../../resources/images/okInShield.svg';
import Icon from '@ant-design/icons';
import { updateInputValue } from "../../Debounce";
import { Tooltip } from 'antd';

export const RegulatorProtectButton = ({ ecIsProtected, unitId, ecIsProtectedTitle }) => {
    const [isProtected, setIsProtected] = React.useState(ecIsProtected);

    React.useEffect(() => {
        setIsProtected(ecIsProtected);
    }, [ecIsProtected]);

    return <div
        style={{
            color: isProtected ? '#00FA9E' : '#666',
            fontSize: '50px',
        }}
        onClick={() => {
            setIsProtected((isProtected) => !isProtected);
            updateInputValue(unitId, 'ecIsProtected', !isProtected);
        }}
        className='widget-button'
    >
        <Tooltip
            placement="top"
            title={ecIsProtectedTitle?.title}
        >
            <Icon component={OkInShieldSvg} />
        </Tooltip>
    </div>
}